var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 74,
    viewBox: "0 0 105 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.463 0H2.53675C1.13574 0 0 1.09073 0 2.4362V71.5638C0 72.9093 1.13574 74 2.53675 74H102.463C103.864 74 105 72.9093 105 71.5638V2.4362C105 1.09073 103.864 0 102.463 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.39595V2.43499C-4.12617e-08 2.11512 0.0656236 1.79839 0.193123 1.50288C0.320622 1.20738 0.507497 0.93889 0.743073 0.712765C0.978648 0.486639 1.25831 0.307305 1.56607 0.185006C1.87384 0.0627076 2.20368 -0.000158917 2.53675 3.01676e-07H102.463C102.796 -0.000158917 103.126 0.0627076 103.434 0.185006C103.742 0.307305 104.021 0.486639 104.257 0.712765C104.493 0.93889 104.679 1.20738 104.807 1.50288C104.934 1.79839 105 2.11512 105 2.43499V6.39595H0Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 73.9987V58.2083C13.1992 58.2083 13.9148 56.6714 14.7983 56.6714H44.5136C44.9378 56.6717 45.3445 56.8338 45.6443 57.122C45.9442 57.4101 46.1126 57.8009 46.1126 58.2083V73.9987H13.1992Z",
    fill: "#F2EAE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9279 55.1998H54.8945V18.8386H91.9992V49.382",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3945 24.5934H34.0575",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3945 31.9507H34.8703",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1875 24.5934H44.2248",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 6.23358C2.10938 6.23358 96.7932 6.62992 99.065 6.46872",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49 4.32704C5.14032 4.32704 5.66751 3.82074 5.66751 3.1962C5.66751 2.57166 5.14032 2.06537 4.49 2.06537C3.83969 2.06537 3.3125 2.57166 3.3125 3.1962C3.3125 3.82074 3.83969 4.32704 4.49 4.32704Z",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40797 4.32704C9.05829 4.32704 9.58548 3.82074 9.58548 3.1962C9.58548 2.57166 9.05829 2.06537 8.40797 2.06537C7.75765 2.06537 7.23047 2.57166 7.23047 3.1962C7.23047 3.82074 7.75765 4.32704 8.40797 4.32704Z",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5924 9.3775H6.38747C6.03756 9.3775 5.75391 9.64991 5.75391 9.98595V12.8088C5.75391 13.1448 6.03756 13.4172 6.38747 13.4172H19.5924C19.9423 13.4172 20.226 13.1448 20.226 12.8088V9.98595C20.226 9.64991 19.9423 9.3775 19.5924 9.3775Z",
    fill: "#3098F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0047 43.7837H15.2265C14.7713 43.7837 14.4023 44.138 14.4023 44.5752V49.5324C14.4023 49.9695 14.7713 50.3239 15.2265 50.3239H37.0047C37.4598 50.3239 37.8288 49.9695 37.8288 49.5324V44.5752C37.8288 44.138 37.4598 43.7837 37.0047 43.7837Z",
    fill: "#FE6571"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 45.5571L36.5109 47.1934L34.6797 48.6806",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9062 10.9932H83.2486",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6445 10.9932H90.9868",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3867 10.9932H98.7303",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.418 73.1214C24.102 71.45 25.2896 69.4259 26.0683 68.2102C28.34 64.6953 31.3967 60.6628 33.5991 61.5234C36.5434 62.6748 33.0362 67.3848 34.7134 68.3508C36.5018 69.381 38.4164 66.1497 39.7201 66.2503C42.5206 66.4673 40.6881 72.4596 40.288 73.502",
    stroke: "#092C4E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8199 32.2028L83.0976 30.0866C83.3 29.8464 83.4512 29.5703 83.5426 29.274C83.6339 28.9777 83.6636 28.667 83.6299 28.3597C83.5962 28.0524 83.4998 27.7545 83.3462 27.4829C83.1926 27.2114 82.9849 26.9715 82.7348 26.7771C82.4847 26.5827 82.1971 26.4375 81.8886 26.3498C81.5801 26.2621 81.2566 26.2336 80.9366 26.2659C80.6166 26.2983 80.3063 26.3909 80.0236 26.5384C79.7409 26.6859 79.4911 26.8854 79.2887 27.1256L76.5664 25.0082C77.5646 23.8439 79.0013 23.1055 80.5637 22.9539C82.1262 22.8022 83.6877 23.2496 84.9082 24.1986C86.1288 25.1476 86.9094 26.5212 87.0802 28.0204C87.2509 29.5196 86.7979 31.0229 85.8199 32.2028Z",
    fill: "#FFCC00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3418 42.1391C72.2746 42.1391 76.2734 38.2987 76.2734 33.5614C76.2734 28.8242 72.2746 24.9838 67.3418 24.9838C62.409 24.9838 58.4102 28.8242 58.4102 33.5614C58.4102 38.2987 62.409 42.1391 67.3418 42.1391Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsIcon);
export default __webpack_public_path__ + "static/media/ds-icon.939e022f6651344b41afb8845a743a4f.svg";
export { ForwardRef as ReactComponent };